/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StartBuildUploadResponseSchema
 */
export interface StartBuildUploadResponseSchema {
    /**
     * 
     * @type {Array<string>}
     * @memberof StartBuildUploadResponseSchema
     */
    partUrls: Array<string>;
}

/**
 * Check if a given object implements the StartBuildUploadResponseSchema interface.
 */
export function instanceOfStartBuildUploadResponseSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "partUrls" in value;

    return isInstance;
}

export function StartBuildUploadResponseSchemaFromJSON(json: any): StartBuildUploadResponseSchema {
    return StartBuildUploadResponseSchemaFromJSONTyped(json, false);
}

export function StartBuildUploadResponseSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): StartBuildUploadResponseSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'partUrls': json['part_urls'],
    };
}

export function StartBuildUploadResponseSchemaToJSON(value?: StartBuildUploadResponseSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'part_urls': value.partUrls,
    };
}

